import { isEmail } from '@webapp/common/lib/ui';

import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class EmailApi extends QuestionSimpleApi {
    public query(actor: QuestionActor): AnswersRequest {
        const { answersActors, id, responseActor } = actor.getSnapshot().context;
        const { comment } = responseActor.getSnapshot().context;
        return {
            question: id,
            data: answersActors.map((answerActor) => {
                const { id, response } = answerActor.getSnapshot().context;
                const { value } = response.getSnapshot().context;
                return { answer: id, text: value as string, bool: true };
            }),
            comment: comment,
        };
    }

    public validate({ answersActors, params: { required } }: QuestionContext): boolean {
        if (!required) return true;

        const validEmailCount = answersActors.reduce((acc, answerActor) => {
            const { response } = answerActor.getSnapshot().context;
            const { value } = response.getSnapshot().context;
            return acc + Number(!!value && isEmail(value as string));
        }, 0);

        return validEmailCount === answersActors.length;
    }
}
